




import { Component, Vue, Prop } from 'vue-property-decorator';
import { getStringFirstAndLast } from '@/utils/user';


@Component({
  filters: {
    nameFormat(username: string) {
      return getStringFirstAndLast(username);
    },
  },
})
export default class Avatar extends Vue {
  @Prop({required: true, default: () => ''}) private userName!: string;
}
